import { render, staticRenderFns } from "./drawerStudent.vue?vue&type=template&id=779c32eb&scoped=true"
import script from "./drawerStudent.vue?vue&type=script&lang=js"
export * from "./drawerStudent.vue?vue&type=script&lang=js"
import style0 from "./drawerStudent.vue?vue&type=style&index=0&id=779c32eb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779c32eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('779c32eb')) {
      api.createRecord('779c32eb', component.options)
    } else {
      api.reload('779c32eb', component.options)
    }
    module.hot.accept("./drawerStudent.vue?vue&type=template&id=779c32eb&scoped=true", function () {
      api.rerender('779c32eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/merchantAccount/components/drawerStudent.vue"
export default component.exports